import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import mdEntityService from 'core/metamodel/mdEntityService'
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import ConfirmationDialog from 'core/components/confirmationDialog/confirmationDialog';
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {History} from "react-router";
import {preSave} from "core/form/formUtils";
import {action} from "mobx";
import uiService from "core/common/service/uiService";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import 'core/components/blockComp/blockComp.less';
import {Contract, CONTRACTSTATUS, CONTRACTTYPE, Document} from "core/document/documentDomain";
import documentService from "core/document/documentService";
import ContractForm from "core/document/component/contractForm";
import GridDocumentComp from "core/document/component/gridDocumentComp";
import {GridDocument} from "core/document/gridDocument";
import {loc} from "../common/config/locales";


@observer
export default class ContractDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Contract';
  static icon = 'handshake-o';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("ContractDetail#fetchData(%O)", query);


    let promiseArray: Promise<any>[] = [mdEntityService.fetchEntityMetadata(['Contract'], ["Document"])];

    if (routerParams.id === 'new') {
      let {customerLabel, customerValue, ...other} = query;
      promiseArray.push(Promise.resolve(new Contract({$new: true, active: true, ...other, customer: {value: customerValue, label: customerLabel}})));
      promiseArray.push(Promise.resolve([]));
    } else {
      promiseArray.push(documentService.readContract(routerParams.id));
      promiseArray.push(documentService.readDocuments({contractId: routerParams.id}));
    }

    return Promise.all(promiseArray)
      .then(([entityMap, contractObject, documents]: [any, Contract, Document[]]) => {
        contractObject.$gridDocument = new GridDocument("contractGridDocument", "Docs", {contractId: contractObject.contractId},false, null, documents);
        documentService.contractObject = contractObject.initAfterRead(routerParams.id === 'new');
      });
  }


  @action componentWillUnmount() {
    documentService.contractObject = null;
  }


  findRootObject() {
    return documentService.contractObject;
  }

  customValidate = (contractObject) => {
    let errors = [];

    // if (contractObject.contractType === CONTRACTTYPE.CUSTOMER_CONTRACT && !contractObject.contractNumber) {
    //   errors.push({message: `${mdEntityService.getEntity("CONTRACTTYPE").getLovItemLabel(CONTRACTTYPE.CUSTOMER_CONTRACT)} requires Contract Number`});
    // }

    return errors;
  };


  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(documentService.contractObject, this.customValidate);
    if (!result) {
      return;
    }

    let wasNew: boolean;

    return documentService.saveContract(documentService.contractObject)
      .then(action("contractSave-callback", (contractJson: any) => {
        wasNew = documentService.contractObject.cleanAfterSave(contractJson);
        return this.docSavingPromise(documentService.contractObject.$gridDocument, {contractId: documentService.contractObject.contractId});
      })).then(x => {
        if(wasNew) {
          this.context.router.replaceWith('contractDetail', {id: documentService.contractObject.contractId});
        }
        uiService.hideToolbarActionFlag();
      }).catch(error => {
        documentService.contractObject.$errors = error.getMessages();
      });
  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    documentService.deleteContract(documentService.contractObject.contractId)
      .then(response => {
        this.goBackOrHome();
      }, error => {
        documentService.contractObject.$errors = error.getMessages();
      });
  };

  onAdd = (evt) => {
    console.log('onAdd');
    let query = {contractStatus: CONTRACTSTATUS.DRAFT, contractType: CONTRACTTYPE.CUSTOMER_CONTRACT};
    this.context.router.transitionTo("contractDetail", {id: 'new'}, query);
  };

  render() {

    let {
      query
    } = this.props;

    console.debug('%c taskDetail render query %O', 'background-color: yellow', this.props.query);


    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
        {this._createToolMenu(documentService.contractObject, query.gridLocation)}
        <ErrorComp messages={documentService.contractObject.$errors} />
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
        <form style={{marginTop: 10}}>
          <div className="row">
            <div className="col-xs-12">
              <ContractForm dataObject={documentService.contractObject}
                                  rootObject={documentService.contractObject}
                                  entity={mdEntityService.getEntity("Contract")}
                                  entities={mdEntityService.entityMap}/>
            </div>
          </div>
        </form>
        <GridDocumentComp grid={documentService.contractObject.$gridDocument}
                          entities={mdEntityService.entityMap} rootObject={documentService.contractObject} />

      </main>
    );

  }


  _createToolMenu(contractObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}
                entityName="Task" entityId={contractObject.contractId} >

        <ZzFlatButton onClick={this.onSave} disabled={!contractObject.$dirty} label="Save"
                        permission={contractObject.$new ? PERMISSION.New : PERMISSION.Update}/>

        <ZzFlatButton onClick={this.onAdd} disabled={contractObject.$new} label="New" permission={PERMISSION.New}/>

        <WithDeleteDialogZzFlatButton entityName="Contract" pageAncestor={this} onClick={this.onDelete} disabled={contractObject.$new} label="Delete"
                      permission={PERMISSION.Delete}/>

      </Toolmenu>
    );
  }


}






// WEBPACK FOOTER //
// ./src/core/document/contractDetail.tsx